"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MailIcon = function MailIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "26px", height: "26px", viewBox: "0 0 26 26", version: "1.1" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-206.000000, -608.000000)" },
        _react2.default.createElement(
          "g",
          { transform: "translate(0.000000, 540.000000)" },
          _react2.default.createElement(
            "g",
            { transform: "translate(194.000000, 59.000000)" },
            _react2.default.createElement(
              "g",
              { transform: "translate(12.000000, 9.000000)" },
              _react2.default.createElement("rect", { x: "0", y: "0", width: "26", height: "26" }),
              _react2.default.createElement(
                "g",
                { transform: "translate(3.466667, 1.733333)" },
                _react2.default.createElement(
                  "g",
                  { transform: "translate(0.000000, 6.933333)" },
                  _react2.default.createElement("path", {
                    d: "M17.875,11.7000037 L1.19166667,11.7000037 C0.533866667,11.7000037 0,11.1758437 0,10.5300037 L0,3.65625e-06 L19.0666667,3.65625e-06 L19.0666667,10.5300037 C19.0666667,11.1758437 18.5328,11.7000037 17.875,11.7000037",
                    fill: "#9ABFFF",
                    mask: "url(#mask-2)"
                  })
                ),
                _react2.default.createElement("path", {
                  d: "M0,7.09077479 L9.1806,12.885361 C9.28546667,12.962181 9.4094,13 9.53333333,13 C9.65726667,13 9.7812,12.962181 9.88606667,12.885361 L19.0666667,7.09077479 L9.89083333,0.117889043 C9.67871667,-0.0392963476 9.38795,-0.0392963476 9.17583333,0.117889043 L0,7.09077479 Z",
                  fill: "#C4D7FF"
                }),
                _react2.default.createElement(
                  "g",
                  { transform: "translate(0.000000, 11.266667)" },
                  _react2.default.createElement("path", {
                    d: "M17.875,7.80000375 L1.19166667,7.80000375 C0.523141667,7.80000375 0,7.27320375 0,6.60000375 C0,6.40920375 0.0905666667,6.22920375 0.2431,6.11640375 L9.1806,0.11640375 C9.28546667,0.03836625 9.4094,3.75e-06 9.53333333,3.75e-06 C9.65726667,3.75e-06 9.7812,0.03836625 9.88606667,0.11640375 L18.8235667,6.11640375 C18.9761,6.22920375 19.0666667,6.40920375 19.0666667,6.60000375 C19.0666667,7.27320375 18.543525,7.80000375 17.875,7.80000375",
                    fill: "#79A6EA",
                    mask: "url(#mask-4)"
                  })
                )
              )
            )
          )
        )
      )
    )
  );
};

exports.default = MailIcon;